import React from 'react';
import { Link } from 'react-router-dom';

function FinancialReports() {
    const reports = [
        {
            title: 'Day Book',
            description: 'Daily transaction summary with chronological listing of all vouchers.',
            path: '/accounting/reports/day-book',
            icon: '📋',
            color: 'blue'
        },
        {
            title: 'Cash Book',
            description: 'Cash transactions with opening and closing balances for cash accounts.',
            path: '/accounting/reports/cash-book',
            icon: '💵',
            color: 'green'
        },
        {
            title: 'Bank Book',
            description: 'Bank transactions with account-wise reconciliation and balances.',
            path: '/accounting/reports/bank-book',
            icon: '🏦',
            color: 'purple'
        },
        {
            title: 'Trial Balance',
            description: 'Account balances as of a specific date to verify double-entry accuracy.',
            path: '/accounting/reports/trial-balance',
            icon: '⚖️',
            color: 'yellow'
        },
        {
            title: 'Balance Sheet',
            description: 'Financial position showing assets, liabilities, and equity as of a date.',
            path: '/accounting/reports/balance-sheet',
            icon: '📊',
            color: 'indigo'
        },
        {
            title: 'Profit & Loss',
            description: 'Income vs expenses for a period to determine profitability.',
            path: '/accounting/reports/profit-loss',
            icon: '📈',
            color: 'red'
        },
        {
            title: 'Income & Expense',
            description: 'Daily tracking of income and expenses with trend analysis.',
            path: '/accounting/reports/income-expense',
            icon: '💹',
            color: 'teal'
        },
        {
            title: 'Ledger Statement',
            description: 'Account-wise transaction history with running balances.',
            path: '/accounting/reports/ledger-statement',
            icon: '📝',
            color: 'slate'
        }
    ];

    const colorClasses = {
        blue: { bg: 'bg-blue-50', border: 'border-blue-100', icon: 'bg-blue-100 text-blue-600', button: 'bg-blue-600 hover:bg-blue-700' },
        green: { bg: 'bg-emerald-50', border: 'border-emerald-100', icon: 'bg-emerald-100 text-emerald-600', button: 'bg-emerald-600 hover:bg-emerald-700' },
        purple: { bg: 'bg-purple-50', border: 'border-purple-100', icon: 'bg-purple-100 text-purple-600', button: 'bg-purple-600 hover:bg-purple-700' },
        yellow: { bg: 'bg-amber-50', border: 'border-amber-100', icon: 'bg-amber-100 text-amber-600', button: 'bg-amber-600 hover:bg-amber-700' },
        indigo: { bg: 'bg-indigo-50', border: 'border-indigo-100', icon: 'bg-indigo-100 text-indigo-600', button: 'bg-indigo-600 hover:bg-indigo-700' },
        red: { bg: 'bg-rose-50', border: 'border-rose-100', icon: 'bg-rose-100 text-rose-600', button: 'bg-rose-600 hover:bg-rose-700' },
        teal: { bg: 'bg-teal-50', border: 'border-teal-100', icon: 'bg-teal-100 text-teal-600', button: 'bg-teal-600 hover:bg-teal-700' },
        slate: { bg: 'bg-slate-50', border: 'border-slate-100', icon: 'bg-slate-100 text-slate-600', button: 'bg-slate-600 hover:bg-slate-700' }
    };

    return (
        <div className="max-w-7xl mx-auto px-4 py-8">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Link to="/accounting" className="p-2 text-slate-400 hover:text-indigo-600 rounded-lg transition-colors">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                    </Link>
                    <h1 className="text-3xl font-bold text-slate-800">Financial Reports</h1>
                </div>
                <p className="text-slate-600">Generate and view comprehensive financial reports for {window.CURRENT_FIRM?.name || 'your business'}</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {reports.map((report) => {
                    const colors = colorClasses[report.color];
                    return (
                        <div
                            key={report.path}
                            className={`${colors.bg} border ${colors.border} rounded-xl p-6 transition-all hover:shadow-lg`}
                        >
                            <div className={`w-12 h-12 ${colors.icon} rounded-lg flex items-center justify-center text-2xl mb-4`}>
                                {report.icon}
                            </div>
                            <h3 className="text-lg font-bold text-slate-800 mb-2">{report.title}</h3>
                            <p className="text-sm text-slate-600 mb-4 min-h-[48px]">{report.description}</p>
                            <Link
                                to={report.path}
                                className={`inline-flex items-center gap-2 px-4 py-2 ${colors.button} text-white text-sm font-medium rounded-lg transition-colors`}
                            >
                                View Report
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                </svg>
                            </Link>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default FinancialReports;
